/**
 * Patient-care template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/
import Global from './lib/global';
import Logger from './lib/logger';
import ThemeSplitPaneSlider from './partials/ThemeSplitPaneSlider';
import { ThemeFullBackgroundCarousel } from "./partials/ThemeFullBackgroundCarousel";

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
const NAME = 'PATIENT CARE';
const themeSplitPaneSliderDom = document.querySelector(`[data-theme-split-pane-slider]`);

let heroCarousel;
const heroCarouselDom = document.getElementById("hero_carousel");

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
/**
 *  init --- Initialize the page
 */
function init() {
	Logger.info(`${NAME} > init`);
	initSplitPaneSlider();

	/**
	 * Initialize the “HERO” Carousel
	 */
	if (heroCarouselDom) {
		heroCarousel = new ThemeFullBackgroundCarousel();
	}
}

/**
 * initSplitPaneSlider - Initialize the split pane slider
 */
const initSplitPaneSlider = () => {
	Logger.info(`${NAME} > initSplitPaneSlider`);
	const el = new ThemeSplitPaneSlider(themeSplitPaneSliderDom);
	el.init();
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
